<template>
  <v-inventory-view
    name="counts"
    title="inventory_counts"
    large
    to="/inventory/counts"
    v-bind:headers="headers"
    no-total
    no-receive
    count
  >
    <template #header="{data}">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">{{data.p_order}}</v-list-item-title>
          <v-list-item-subtitle>{{data.status}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('date')}}:</span>
            <span class="body-2">{{(new Date(data.created_time)).toLocaleString()}}</span>
          </v-list-item-title>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('created_by')}}:</span>
            <span class="body-2">{{data.created_by}}</span>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('store')}}:</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="body-2">{{data.service_name}}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-inventory-view>
</template>
<script>
export default {
  name: "InventoryCounts",
  data: () => ({
    headers: [
      { text: "Item", value: "name" },
      {
        text: "Expected stock",
        value: "exp_in_stock",
        align: "right",
        width: 200,
      },
      { text: "Counted", value: "value", align: "right" },
      { text: "Difference", value: "difference", align: "right" },
      { text: "Cost difference", value: "cost_difference", align: "right" },
    ],
  }),
  mounted() {
    this.headers = [
      { text: this.$t("item"), value: "name", width: 50 },
      {
        text: this.$t("expected_stock"),
        value: "exp_in_stock",
        align: "right",
        width: 200,
      },
      {
        text: this.$t("counted"),
        value: "counted",
        align: "right",
        width: 100,
      },
      {
        text: this.$t("difference"),
        value: "difference",
        align: "right",
        width: 100,
      },
      {
        text: this.$t("cost_difference"),
        value: "cost_difference",
        align: "right",
        width: 150,
      },
    ];
  },
};
</script>
